import type { Point, TableProps } from "./types";

const BORDER_OFFSET = 15; // Inset of the first/last seat from the table corners

/**
 * Seat positions along a table's long sides, in plan coordinates with the y axis already
 * flipped (screen-down is positive), indexed by seat number - 1. `inset` moves both rows
 * from the table edges towards its middle.
 */
export const getSeatPositions = ({ x, y, size, width, height, orientation }: TableProps, inset = 0): Point[] => {
    const top = -y;
    const positions: Point[] = [];

    if (orientation === "horizontal") {
        // Seats along the long sides:  1 3 5
        //                              2 4 6
        const seatsPerRow = Math.ceil(size / 2);
        const spacing = seatsPerRow > 1 ? (width - 2 * BORDER_OFFSET) / (seatsPerRow - 1) : 0;

        for (let i = 0; i < size; i++) {
            const row = i % 2;
            const col = Math.floor(i / 2);
            positions.push({
                x: seatsPerRow === 1 ? x + width / 2 : x + BORDER_OFFSET + col * spacing,
                y: row === 0 ? top + inset : top + height - inset,
            });
        }
    } else {
        // Seats along the long sides:  1 2
        //                              3 4
        const seatsPerCol = Math.ceil(size / 2);
        const spacing = seatsPerCol > 1 ? (height - 2 * BORDER_OFFSET) / (seatsPerCol - 1) : 0;

        for (let i = 0; i < size; i++) {
            const col = i % 2;
            const row = Math.floor(i / 2);
            positions.push({
                x: col === 0 ? x + inset : x + width - inset,
                y: seatsPerCol === 1 ? top + height / 2 : top + BORDER_OFFSET + row * spacing,
            });
        }
    }

    return positions;
};
